/*
 * 2/10: Udregner gyldige afhentningsdatoer for "Henter du selv i butikken?"-accordion'en på
 * kurv-siden/kurv-skuffen, og gemmer kundens valg som cart attributes ("Ønsket afhentningsbutik" /
 * "Ønsket afhentningsdato"), der følger med ordren til Shopify admin.
 *
 * Samme regler som store-availability-custom.js bruger på produktsiden:
 *   - Odense: enhver hverdag (man-fre), fra i morgen og ca. 4 uger frem.
 *   - København: kun torsdage. Næste gyldige torsdag beregnes med samme
 *     onsdags-bestillingsfrist-logik som på produktsiden, og der vises 8 torsdage frem fra den.
 *
 * Selve åben/luk-adfærden styres af temaets egen accordion (<details data-collapsible>).
 *
 * 7/10: Felterne er kun aktive, hvis alle varer i kurven er på lager (data-pickup-state="ok", sat af
 * snippets/cart-pickup-schedule.liquid). Kurv-skuffen genindlæser ikke dette afsnit, når der lægges
 * en vare i kurven, så scriptet genhenter tilstanden fra serveren, hver gang kurven/skuffen ændrer
 * sig, og skifter mellem felter og besked. Er tilstanden "blocked", nulstilles felterne, og et
 * gemt ønske ryddes fra kurven.
 */
(function () {
  var DK_MONTHS = [
    'januar', 'februar', 'marts', 'april', 'maj', 'juni',
    'juli', 'august', 'september', 'oktober', 'november', 'december'
  ];
  var DK_DAYS = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];

  // 22/10: Engelsk tekst på /en (sproget læses fra <html lang>). Den danske tekst er uændret, og
  // datoen, der gemmes på ordren (option.value), er altid den danske, så den ser ens ud i admin.
  var IS_EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var EN_MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  var EN_DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function t(da, en) {
    return IS_EN ? en : da;
  }

  function formatEnDate(date) {
    return EN_DAYS[date.getDay()] + ' ' + date.getDate() + ' ' + EN_MONTHS[date.getMonth()] + ' ' + date.getFullYear();
  }

  function capitalize(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  function formatDkDate(date) {
    return capitalize(DK_DAYS[date.getDay()]) + ' d. ' + date.getDate() + '. ' +
      DK_MONTHS[date.getMonth()] + ' ' + date.getFullYear();
  }

  function addDays(date, days) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
  }

  function buildOdenseDates(today, count) {
    var dates = [];
    var cursor = addDays(today, 1);
    while (dates.length < count) {
      var dow = cursor.getDay();
      if (dow >= 1 && dow <= 5) {
        dates.push(cursor);
      }
      cursor = addDays(cursor, 1);
    }
    return dates;
  }

  function buildCopenhagenDates(today, count) {
    var dow = today.getDay();
    var daysUntilThursday = dow <= 3 ? (4 - dow) : (4 - dow + 7);
    var firstThursday = addDays(today, daysUntilThursday);

    var dates = [];
    for (var i = 0; i < count; i++) {
      dates.push(addDays(firstThursday, i * 7));
    }
    return dates;
  }

  function populateDateSelect(selectEl, dates, selectedLabel) {
    selectEl.innerHTML = '';

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = t('Vælg dato (valgfrit)', 'Choose date (optional)');
    selectEl.appendChild(placeholder);

    dates.forEach(function (date) {
      var label = formatDkDate(date);
      var option = document.createElement('option');
      option.value = label;
      option.textContent = IS_EN ? formatEnDate(date) : label;
      if (selectedLabel && label === selectedLabel) {
        option.selected = true;
      }
      selectEl.appendChild(option);
    });

    selectEl.disabled = false;
  }

  function clearSavedWish() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Ønsket afhentningsbutik': '', 'Ønsket afhentningsdato': '' } })
    }).catch(function () {});
  }

  // Kurv-siden og kurv-skuffen har hver sin kopi af afsnittet, så alt køres pr. root-element.
  function init(root) {
    var container = root.querySelector('.cart-pickup-schedule');
    if (!container) return;

    var locationSelect = container.querySelector('[data-pickup-schedule-location]');
    var dateSelect = container.querySelector('[data-pickup-schedule-date]');
    var note = container.querySelector('[data-pickup-schedule-note]');
    if (!locationSelect || !dateSelect) return;

    var today = new Date();
    var selectedLocation = container.getAttribute('data-selected-location') || '';
    var selectedDate = container.getAttribute('data-selected-date') || '';

    function resetDateSelect() {
      dateSelect.innerHTML = '<option value="">' + t('Vælg butik først', 'Choose a store first') + '</option>';
      dateSelect.disabled = true;
      note.textContent = '';
    }

    function refreshDates(location, preserveSelection) {
      if (location === 'Odense') {
        populateDateSelect(dateSelect, buildOdenseDates(today, 20), preserveSelection ? selectedDate : null);
        note.textContent = t('I Odense kan I normalt afhente samme eller næste hverdag.', 'In Odense you can usually collect the same or next business day.');
      } else if (location === 'København') {
        populateDateSelect(dateSelect, buildCopenhagenDates(today, 8), preserveSelection ? selectedDate : null);
        note.textContent = t('I København er afhentning kun muligt om torsdagen.', 'In Copenhagen, pickup is only possible on Thursdays.');
      } else {
        resetDateSelect();
      }
    }

    // Anvender tilstanden fra serveren: "ok" = felterne er aktive, "blocked" = nulstillet og deaktiveret.
    function applyState(state) {
      if (state === 'blocked') {
        var hadWish = !!(selectedLocation || selectedDate || locationSelect.value || dateSelect.value);
        locationSelect.value = '';
        locationSelect.disabled = true;
        resetDateSelect();
        container.open = false;
        selectedLocation = '';
        selectedDate = '';
        if (hadWish) clearSavedWish();
      } else {
        locationSelect.disabled = false;
        refreshDates(locationSelect.value, true);
      }
    }

    if (root.getAttribute('data-pickup-state') === 'blocked') {
      applyState('blocked');
    } else {
      if (selectedLocation) {
        locationSelect.value = selectedLocation;
        container.open = true;
      }
      refreshDates(locationSelect.value, true);
    }

    locationSelect.addEventListener('change', function () {
      refreshDates(locationSelect.value, false);
    });

    root.__pickupApi = { applyState: applyState };
  }

  // Genhenter den aktuelle tilstand ("ok"/"blocked") fra serveren, når kurven/skuffen ændres.
  function watch(root) {
    if (root.__pickupWatched) return;
    root.__pickupWatched = true;

    var section = root.closest('[id^="shopify-section-"]');
    if (!section) return;
    var sectionId = section.id.replace('shopify-section-', '');
    var timer = null;
    var busy = false;

    function check() {
      if (busy) return;
      busy = true;
      fetch('/?sections=' + encodeURIComponent(sectionId) + '&_=' + Date.now())
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var html = json && json[sectionId];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-pickup-schedule-root]');
          if (!fresh) return;
          var next = fresh.getAttribute('data-pickup-state');
          if (next === root.getAttribute('data-pickup-state')) return;
          root.setAttribute('data-pickup-state', next);
          if (root.__pickupApi) root.__pickupApi.applyState(next);
        })
        .catch(function () {})
        .then(function () { busy = false; });
    }

    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(check, 400);
    }).observe(section, { childList: true, subtree: true });
  }

  function start() {
    var roots = document.querySelectorAll('[data-pickup-schedule-root]');
    for (var i = 0; i < roots.length; i++) {
      init(roots[i]);
      watch(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
